type Props = {
  title: string;
};

export default function WizardStepHeader({ title }: Props) {
  return (
    <div className="flex items-center gap-2 mb-4">
      <span className="h-5 w-[3px] rounded-full bg-primaryVar-300" />
      <h2 className="text-base font-semibold text-gray-700">{title}</h2>
    </div>
  );
}
